export function ClearLocalStorage() {
  localStorage.clear();
  sessionStorage.clear();
  window.location.reload()
}
